<template>
  <section>
  <div class="d-xs-none d-block d-flex pinned-card p-3 shadow" :class="{'active': isPinnedCard}">
     <img
            :src="fileUrl(product.icon)"
            :alt="product.name"
            :width="60"
            :height="60"
            class="rounded"
            itemprop="logo"
            :style="`min-width: 60px`"
      >
      <h6 class="px-3 mb-0 w-100">
        <small class="my-2">{{ product.name }}</small>
        <ProductDownload :product="product" class="mt-2"/>
      </h6>
    </div>
  <div class="product-summary card-shadow d-sm-flex align-self-center text-dark bg-light px-5 py-4 mb-5 flex-column d-xs-block"
       :class="{'pt-6': !isUserLoggedIn }" >
   <div v-if="!isUserLoggedIn && tenantLoginType === 'organic' && product.tenantProduct.rightType
     !== 'Free' && tenantDesignConfig.general.hasFeedback" class="my-3">
      <span class="gift w-100 d-block p-2">{{ $t('login.oneMonthGift') }}</span>
   </div>
    
    <div class="row mt-6">
      <div class="flex-md-row flex-xxs-column d-md-flex d-sm-block col-sm-12 col-md-9 p-0">
        <div class="d-xs-none d-xxs-block text-center game-logo">
          <GameIconDownload :product="product"/>
        <!--<img-->
            <!--:src="fileUrl(product.icon)"-->
            <!--:alt="product.name"-->
            <!--:width="imageSize"-->
            <!--:height="imageSize"-->
            <!--itemprop="logo"-->
            <!--:style="`min-width: ${imageSize}px`"-->
          <!--/>-->
        </div>
        <div class="d-flex flex-row">
          <GameIconDownload class="d-xxs-none d-xs-block" :product="product"/>
          <!--<img-->
            <!--:src="fileUrl(product.icon)"-->
            <!--:alt="product.name"-->
            <!--:width="imageSize"-->
            <!--:height="imageSize"-->
            <!--class="d-xxs-none d-xs-block"-->
            <!--itemprop="logo"-->
            <!--:style="`min-width: ${imageSize}px`"-->
          <div class="d-md-none align-items-xxs-center align-items-xs-start d-xxs-flex flex-column w-100 justify-content-xxs-center justify-content-xs-center mx-xxs-2 mx-sm-3">
            <h1 itemprop="name" class="h2">
              <small>{{ product.name }}</small>
            </h1>
            <StarRating
            v-if="tenantLoginType === 'organic'"
            :name="'starRate'+product.name" 
            :read-only="true"
            :show-rating="false" 
            :star-size="30" 
            :border-width="0"
            :rating="averageRate"
            inactive-color="#d1d1d1"
            :round-start-rating="true"
            class="star-rate d-flex align-items-center mb-2"/>
          </div>
        </div>
        <div class="d-md-none d-block mt-2 mt-md-0" id="download-component">
          <ProductDownload :product="product"/>
        </div>
        <div class="d-flex flex-column mx-md-4 mx-xxs-1">
          <div class="d-md-flex d-xxs-none flex-column">
            <h1 itemprop="name" class="h2">
              {{ product.name }}
            </h1>
            <StarRating
            v-if="tenantLoginType === 'organic'"
            :name="'starRate'+product.name" 
            :read-only="true"
            :show-rating="false" 
            :star-size="30" 
            :border-width="0"
            :round-start-rating="true"
            inactive-color="#d1d1d1"
            :rating="averageRate"
            class="star-rate d-flex align-items-center mb-2"/>
          </div>
          <div class="mt-md-4 mt-xxs-3 product-description">
            <span
              itemprop="description"
              v-html="product.description"
            >
            </span>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column col-md-3 col-sm-12 p-0" itemscope itemtype="http://schema.org/MediaObject">
        <div class="d-md-block d-none">
          <ProductDownload :product="product"/>
        </div>
        <span v-if="product.type === 'AndroidGame'" class="mt-3">
          {{ $t('product.fileSize') }}
          <span itemprop="contentSize" class="px-1">
            {{ size }}
          </span>
        </span>
      </div>
    </div>
    <div class="d-flex flex-sm-row row flex-xxs-column justify-content-between">
      <div class="d-flex mt-xxs-3">
        <ProductCollections :product="product" />
        <ProductGenres :product="product" />
      </div>
      <div
        v-if="product.age != null"
        class="d-flex mt-xxs-3 px-sm-0 px-xxs-2"
        itemscope
        itemtype="http://schema.org/PeopleAudience"
      >
        <span>{{ $t('product.ageRank') }}</span>
        <span class="text-danger px-2" itemprop="suggestedMinAge">
          {{ product.age }}
        </span>
      </div>
    </div>
    </div>
    <UserReview v-if="tenantLoginType === 'organic'" :product="product"></UserReview>
  </section>
</template>

<script>
import { mapGetters , mapActions } from 'vuex'
import ProductCollections from '@/components/ProductCollections.vue'
import ProductGenres from '@/components/ProductGenres.vue'
import ProductDownload from '@/components/ProductDownload.vue'
import GameIconDownload from '@/components/GameIconDownload.vue'
import UserReview from '@/components/UserReview'
import StarRating from 'vue-star-rating'

export default {
  name: 'ProductSummary',
  components: {
    ProductCollections,
    ProductGenres,
    ProductDownload,
    GameIconDownload,
    UserReview,
    StarRating
  },
  data()
  {
    return{
      isShowMoreActivated:false,
      isPinnedCard: false,
      averageRate:0
    }
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl',
      productRate: 'userReview/productRate',
      tenantDesignConfig: 'tenantDesign/config',
      isUserLoggedIn: 'auth/isUserAuthenticated'
    }),
    tenantLoginType () {
      return this.tenantDesignConfig.userManagement.loginType.toLowerCase()
    },
    imageSize () {
      return 100
    },
    size () {
      let size = this.product.size
      if (size < 1024) {
        return size + this.$t('common.byte')
      } else if (size < 1024 * 1024) {
        return Math.round((size / 1024)) + this.$t('common.kb')
      } else if (size < 1024 * 1024 * 1024) {
        return (
          Math.round((size / (1024 * 1024))) +
          this.$t('common.mb')
        )
      } else if (size < 1024 * 1024 * 1024 * 1024) {
        return (
          Math.round((size / (1024 * 1024 * 1024)) * 100) / 100 +
         this.$t('common.gb')
        )
      } else {
        return ''
      }
    },
    downloadButtonText () {
      switch (this.product.type) {
        case 'HtmlGame':
          return this.$t('product.play', { product: this.globalResources.productTranslation.Single })
        case 'AndroidGame':
          return this.$t('product.download')
        default:
          return ''
      }
    },
  },
  methods: {
    ...mapActions({
      getProductRate: 'userReview/getProductRate'
    }),
    download () {
      this.$emit('download')
    },
    copyToClipboard () {
      var dummy = document.createElement('input')
      var text = window.location.href
      document.body.appendChild(dummy)
      dummy.value = text
      dummy.select()
      try {
        var successful = document.execCommand('copy')
        dummy.remove()
        alert(this.$t('product.productUrlCopiedToClipboard', { product: this.globalResources.productTranslation.Single }))
      } catch (err) {
        alert(this.$t('product.productUrlDoesNotCopiedToClipboard', { product: this.globalResources.productTranslation.Single }))
      }
    },
    displayTrimedText()
    {
      this.isShowMoreActivated = true
    },
  },
  created()
  {
    console.log('asdasdasd',this.product)
    if(this.product.description.lentgh === 0)
    {
      this.isShowMoreActivated = false
    }
    window.onscroll = () => {
        let windowTop = $(window).scrollTop()
        var top = $('#download-component').offset().top
        if(windowTop > top)
        {
          this.isPinnedCard = true
        }
        else{
          this.isPinnedCard = false
        }
      }
      this.getProductRate(this.product.id).then((response)=>{
        this.averageRate = this.productRate === undefined ? 0 : this.productRate.ratePoint
    })
  },
}
</script>
